import SectionWrapper from "./SectionWrapper";
import { Grid } from "@mui/material";
import { SimpleFormInput } from "../forms/SimpleFormInput";
import { IFeeAmountSectionProps } from "../../interfaces/configuration";

const FeeAmountSection = ({ baseInfo, errors }: IFeeAmountSectionProps) => (
  <SectionWrapper title="Tarifa plana">
    <Grid item xs={6}>
      <SimpleFormInput
        inputTitle="Monto"
        placeholder="Ingresar monto"
        valueName="fee"
        errors={errors.fee}
        {...baseInfo}
        autoFocus
      />
    </Grid>
  </SectionWrapper>
);

export default FeeAmountSection;
